import { useMemo } from "react";
import { diffWords } from "diff";

// Word-level diff between the original prompt and the tightened rewrite.
// Additions (what Coretext added) glow green; removals are struck through in red.
export const PromptDiff = ({ original, improved }) => {
  const parts = useMemo(
    () => diffWords(original || "", improved || ""),
    [original, improved]
  );

  const added = parts.filter((p) => p.added).length;
  const removed = parts.filter((p) => p.removed).length;

  return (
    <div data-testid="prompt-diff">
      <div className="flex items-center gap-4 mb-3 font-mono text-[11px] tracking-[0.15em]">
        <span className="inline-flex items-center gap-1.5 text-neon-green">
          <span className="w-3 h-3 rounded-sm" style={{ background: "rgba(34,229,138,0.35)", border: "1px solid #22e58a" }} />
          ADDED
        </span>
        <span className="inline-flex items-center gap-1.5 text-neon-red">
          <span className="w-3 h-3 rounded-sm" style={{ background: "rgba(255,59,92,0.2)", border: "1px solid #ff3b5c" }} />
          REMOVED
        </span>
        <span className="text-[var(--muted)] ml-auto">
          {added} addition{added === 1 ? "" : "s"} · {removed} removal{removed === 1 ? "" : "s"}
        </span>
      </div>
      <div className="whitespace-pre-wrap font-mono text-sm leading-relaxed bg-[#070910] border border-neon-cyan/25 rounded-xl p-5 max-h-[460px] overflow-auto text-[var(--muted)]">
        {parts.map((p, i) => {
          if (p.added) {
            return (
              <span
                key={i}
                className="text-neon-green rounded-sm"
                style={{ background: "rgba(34,229,138,0.14)", boxShadow: "0 0 0 1px rgba(34,229,138,0.25)" }}
              >
                {p.value}
              </span>
            );
          }
          if (p.removed) {
            return (
              <span
                key={i}
                className="text-neon-red/80 line-through"
                style={{ background: "rgba(255,59,92,0.08)" }}
              >
                {p.value}
              </span>
            );
          }
          return <span key={i} className="text-white/80">{p.value}</span>;
        })}
      </div>
    </div>
  );
};
